import React from 'react';
import Folds from './Folds'
import Header from './Header';
import Stroke from './Stroke'
import Color from './Color';
import Download from './Download'
import Mode from './Mode'

const Knobs = ({ symmetry, strokeSize, onSymmetryChange, onStrokeSizeChange, downloadCanvas, color, onColorChange, onModeChange, mode }) => {
  return (
    <div className="p-2" style={{ backgroundColor: '' }}>
      <Header />
      <Folds symmetry={symmetry} onSymmetryChange={onSymmetryChange} />
      <Stroke strokeSize={strokeSize} onStrokeSizeChange={onStrokeSizeChange}/>
      <Color color={color} onColorChange={onColorChange} />
      <Mode mode={mode} onModeChange={onModeChange} />
      <Download downloadCanvas={downloadCanvas} />
    </div>
  );
};

export default Knobs;